import React from 'react';
import styles from './Platforms.module.scss'
import PlatformsTable from "../../../components/PlatformsTable/PlatformsTable";


const DistributorPlatforms = () => {
    return (
        <div className={styles.container}>
            <PlatformsTable userType={4} getUsage={false} />
        </div>
    )
}

export default DistributorPlatforms;
